export const formatCsvValidationErrors = (errors, exampleCSV) => {
  if (
    !errors ||
    (!Array.isArray(errors) &&
      typeof errors !== "string" &&
      !(errors instanceof Error))
  ) {
    return "There was an error loading the application. Please contact Shelter Animals Count for support.";
  } else if (Array.isArray(errors)) {
    return errors.map((e) => e.toString()).join(", ");
  } else if (errors.toString().includes("Invalid CSV Headers")) {
    const missingHeaders =
      errors
        .toString()
        .split("Missing headers:")?.[1]
        ?.split(",")
        .map((h) => h.trim())
        .filter(Boolean)
        .join(", ") ?? "";

    return `Invalid CSV Headers detected. The following column(s) need to be updated: ${missingHeaders}. Please download the example CSV to see the correct column headers.`;
  } else if (errors.toString().includes("Missing required parameters")) {
    return "The file could not be submitted. Please select a valid CSV file and try again.";
  } else if (errors.toString().includes("unexpected error")) {
    return "An unexpected error occurred while processing your file. Please try again or contact Shelter Animals Count for support.";
  } else {
    return errors.toString();
  }
};
